<div class="modal-header">
  <h5 class="modal-title">User Settings</h5>
  <button type="button" class="btn-close btn-close-white" (click)="close()"  aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="row mb-4">
    <div class="col-6">
      <label for="speedUnits" class="form-label">Speed</label>
    </div>
    <div class="col-6">
      <select class="form-select" name="speedUnits" [(ngModel)]="userPreferences.speedUnits">
        <option [ngValue]="speedUnits.mph">MPH</option>
        <option [ngValue]="speedUnits.kmh">KMH</option>
      </select>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-6">
      <label for="weightUnits" class="form-label">Weight</label>
    </div>
    <div class="col-6">
      <select class="form-select" name="weightUnits" [(ngModel)]="userPreferences.weightUnits">
        <option [ngValue]="weightUnits.lb">lb</option>
        <option [ngValue]="weightUnits.kg">Kg</option>
      </select>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-6">
      <label for="powerUnits" class="form-label">Power</label>
    </div>
    <div class="col-6">
      <select class="form-select" name="powerUnits" [(ngModel)]="userPreferences.powerUnits">
        <option [ngValue]="powerUnits.hp">HP</option>
        <option [ngValue]="powerUnits.kw">KW</option>
        <option [ngValue]="powerUnits.cv">CV</option>
      </select>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-6">
      <label for="torqueUnits" class="form-label">Torque</label>
    </div>
    <div class="col-6">
      <select class="form-select" name="torqueUnits" [(ngModel)]="userPreferences.torqueUnits">
        <option [ngValue]="torqueUnits.ftlb">{{torqueUnits.ftlb.display}}</option>
        <option [ngValue]="torqueUnits.nm">{{torqueUnits.nm.display}}</option>
        <option [ngValue]="torqueUnits.kgfm">{{torqueUnits.kgfm.display}}</option>
      </select>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-6">
      <label for="lengthUnits" class="form-label">Length</label>
    </div>
    <div class="col-6">
      <select class="form-select" name="lengthUnits" [(ngModel)]="userPreferences.lengthUnits">
        <option [ngValue]="lengthUnits.inch">in</option>
        <option [ngValue]="lengthUnits.mm">mm</option>
      </select>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="close()">Close</button>
  <button type="button" class="btn btn-primary" (click)="ok()">Ok</button>
</div>



